'use strict';

$(document).ready(function () {
    setNextLazyWaypoint();
});

var sectionsLoaded = [];

var loadedGuiaCompras = false;

var jcLoader = '<div class="jc-loader text-center mx-auto"><div class="sk-three-bounce"><div class="sk-child sk-bounce1"></div><div class="sk-child sk-bounce2"></div><div class="sk-child sk-bounce3"></div></div></div>';

function setNextLazyWaypoint() {
    $('.lazy-load').eq(0).waypoint({
        handler: function handler() {
            lazyLoadSection($(this.element));
        },
        offset: $(window).height() + 300
    });
}

function lazyLoadSection(section) {

    var sectionData = section.data();
    sectionData.action = 'jc_ajax_lazy_load_section';

    if (sectionData.category) {
        if (sectionsLoaded.indexOf(sectionData.category) != -1) {
            return;
        }

        sectionsLoaded.push(sectionData.category);
    }

    if (sectionData.template == "guia-de-compras") {
        if (loadedGuiaCompras) {
            return;
        } else {
            loadedGuiaCompras = true;
        }
    }

    if (sectionData.template == 'reviews') {
        var styleSkeleton = 'style="height:300px;padding:3px;"';
    }if (sectionData.template == 'ranking-jc') {
        var styleSkeleton = 'style="height:150px;padding:3px;"';
    } else if (sectionData.template == 'guia-de-compras-novo') {
        var styleSkeleton = 'style="height:350px;padding:10px"';
    } else if (sectionData.template == 'web-stories-home') {
        var styleSkeleton = 'style="height:420px;padding:3px;border-radius:10px;"';
    }

    if (sectionData.template == 'carros' || sectionData.template == 'servicos') {

        jcLoader = '<div class="container pt-4">';
        jcLoader += '<div class="row">';
        jcLoader += '<div class="col-md-6 col-12 w-100 p-0">';
        jcLoader += '<div style="height:270px" class="mb-3 skeleton"></div>';
        jcLoader += '<div class="mb-3 skeleton" style="height:25px;width:30%;"></div>';
        jcLoader += '<div class="mb-2 skeleton" style="height:60px;border-radius:15px;"></div>';
        jcLoader += '<div class="mb-2 skeleton" style="height:25px;width:25%;border-radius:15px;"></div>';
        jcLoader += '<div class="skeleton" style="height:30px;border-radius:15px;"></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="col-md-6 col-12 w-100 pr-0 d-none d-sm-block">';
        jcLoader += '<div class="row">';
        jcLoader += '<div class="col-md-8 col-12 w-100 pr-0 d-none d-sm-block">';
        jcLoader += '<div class="mb-2 skeleton" style="height:25px;width:55%;"></div>';
        jcLoader += '<div class="mb-2 skeleton" style="height:40px;border-radius:15px;"></div>';
        jcLoader += '<div class="skeleton" style="height:25px;border-radius:15px;"></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="col-md-4 pt-3 col-12 w-100 d-none d-sm-block">';
        jcLoader += '<div class="mb-3 skeleton pt-2 ml-3" style="height:80px;"></div>';
        jcLoader += '</div>';
        jcLoader += '</div><hr />';
        jcLoader += '<div class="row">';
        jcLoader += '<div class="col-md-8 col-12 w-100 pr-0 d-none d-sm-block">';
        jcLoader += '<div class="mb-2 skeleton" style="height:25px;width:55%;"></div>';
        jcLoader += '<div class="mb-2 skeleton" style="height:40px;border-radius:15px;"></div>';
        jcLoader += '<div class="skeleton" style="height:25px;border-radius:15px;"></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="col-md-4 pt-3 col-12 w-100 d-none d-sm-block">';
        jcLoader += '<div class="mb-3 skeleton pt-2 ml-3" style="height:80px;"></div>';
        jcLoader += '</div>';
        jcLoader += '</div><hr />';
        jcLoader += '<div class="row">';
        jcLoader += '<div class="col-md-8 col-12 w-100 pr-0 d-none d-sm-block">';
        jcLoader += '<div class="mb-2 skeleton" style="height:25px;width:55%;"></div>';
        jcLoader += '<div class="mb-2 skeleton" style="height:40px;border-radius:15px;"></div>';
        jcLoader += '<div class="skeleton" style="height:25px;border-radius:15px;"></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="col-md-4 pt-3 col-12 w-100 d-none d-sm-block">';
        jcLoader += '<div class="mb-3 skeleton pt-2 ml-3" style="height:80px;"></div>';
        jcLoader += '</div>';
        jcLoader += '</div><hr />';
        jcLoader += '</div>';
        jcLoader += '</div>';
        jcLoader += '</div><br />';
    } else if (sectionData.template == 'guia-de-compras-novo') {

        jcLoader = '<div class="container">';
        jcLoader += '<div class="row">';
        jcLoader += '<div class="col-md-6 col-12 w-100">';
        jcLoader += '<div class="skeleton" ' + styleSkeleton + '></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="col-md-6 col-12 w-100 d-none d-sm-block">';
        jcLoader += '<div class="skeleton" ' + styleSkeleton + '></div>';
        jcLoader += '</div>';
        jcLoader += '</div>';
        jcLoader += '</div><br />';
    } else if (sectionData.template == 'reviews') {

        jcLoader = '<div class="container">';
        jcLoader += '<div class="row text-center justify-content-center">';
        jcLoader += '<div class="col-md-3 col-12 h-100">';
        jcLoader += '<div class="card" ' + styleSkeleton + '><div class="card-body">';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 80px;width: 110px;"></div><br />';
        jcLoader += '<div class="mb-2 skeleton" style="margin:0 auto;height:20px;width:90%;border-radius:15px;"></div>';
        jcLoader += '<div class="mb-3 skeleton" style="margin:0 auto;height:25px;width:60%;"></div>';
        jcLoader += '<div class="skeleton" style="margin:0 auto;height:20px;border-radius:15px;"></div>';
        jcLoader += '</div></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="col-md-3 col-12 h-100">';
        jcLoader += '<div class="card" ' + styleSkeleton + '><div class="card-body">';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 80px;width: 110px;"></div><br />';
        jcLoader += '<div class="mb-2 skeleton" style="margin:0 auto;height:20px;width:90%;border-radius:15px;"></div>';
        jcLoader += '<div class="mb-3 skeleton" style="margin:0 auto;height:25px;width:60%;"></div>';
        jcLoader += '<div class="skeleton" style="margin:0 auto;height:20px;border-radius:15px;"></div>';
        jcLoader += '</div></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="col-md-3 col-12 h-100">';
        jcLoader += '<div class="card" ' + styleSkeleton + '><div class="card-body">';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 80px;width: 110px;"></div><br />';
        jcLoader += '<div class="mb-2 skeleton" style="margin:0 auto;height:20px;width:90%;border-radius:15px;"></div>';
        jcLoader += '<div class="mb-3 skeleton" style="margin:0 auto;height:25px;width:60%;"></div>';
        jcLoader += '<div class="skeleton" style="margin:0 auto;height:20px;border-radius:15px;"></div>';
        jcLoader += '</div></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="col-md-3 col-12 h-100">';
        jcLoader += '<div class="card" ' + styleSkeleton + '><div class="card-body">';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 80px;width: 110px;"></div><br />';
        jcLoader += '<div class="mb-2 skeleton" style="margin:0 auto;height:20px;width:90%;border-radius:15px;"></div>';
        jcLoader += '<div class="mb-3 skeleton" style="margin:0 auto;height:25px;width:60%;"></div>';
        jcLoader += '<div class="skeleton" style="margin:0 auto;height:20px;border-radius:15px;"></div>';
        jcLoader += '</div></div>';
        jcLoader += '</div>';
        jcLoader += '</div>';
        jcLoader += '</div><br />';
    } else if (sectionData.template == 'ofertas') {

        jcLoader = '<div class="container">';
        jcLoader += '<div class="row text-center justify-content-center">';
        jcLoader += '<div class="col-md-3 col-12 h-100">';
        jcLoader += '<div class="card" ' + styleSkeleton + '><div class="card-body">';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 50px;width: 90px;"></div><br />';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 120px;"></div><br />';
        jcLoader += '<div class="mb-2 skeleton" style="margin:0 auto;height:20px;width:50%;border-radius:15px;"></div>';
        jcLoader += '<div class="mb-3 skeleton" style="margin:0 auto;height:40px;border-radius:15px;"></div><br /><br />';
        jcLoader += '<div class="skeleton" style="margin:0 auto;height:35px;"></div>';
        jcLoader += '</div></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="col-md-3 col-12 h-100">';
        jcLoader += '<div class="card" ' + styleSkeleton + '><div class="card-body">';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 50px;width: 90px;"></div><br />';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 120px;"></div><br />';
        jcLoader += '<div class="mb-2 skeleton" style="margin:0 auto;height:20px;width:50%;border-radius:15px;"></div>';
        jcLoader += '<div class="mb-3 skeleton" style="margin:0 auto;height:40px;border-radius:15px;"></div><br /><br />';
        jcLoader += '<div class="skeleton" style="margin:0 auto;height:35px;"></div>';
        jcLoader += '</div></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="col-md-3 col-12 h-100">';
        jcLoader += '<div class="card" ' + styleSkeleton + '><div class="card-body">';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 50px;width: 90px;"></div><br />';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 120px;"></div><br />';
        jcLoader += '<div class="mb-2 skeleton" style="margin:0 auto;height:20px;width:50%;border-radius:15px;"></div>';
        jcLoader += '<div class="mb-3 skeleton" style="margin:0 auto;height:40px;border-radius:15px;"></div><br /><br />';
        jcLoader += '<div class="skeleton" style="margin:0 auto;height:35px;"></div>';
        jcLoader += '</div></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="col-md-3 col-12 h-100">';
        jcLoader += '<div class="card" ' + styleSkeleton + '><div class="card-body">';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 50px;width: 90px;"></div><br />';
        jcLoader += '<div class="mb-4 skeleton pt-2" style="margin: 0 auto;height: 120px;"></div><br />';
        jcLoader += '<div class="mb-2 skeleton" style="margin:0 auto;height:20px;width:50%;border-radius:15px;"></div>';
        jcLoader += '<div class="mb-3 skeleton" style="margin:0 auto;height:40px;border-radius:15px;"></div><br /><br />';
        jcLoader += '<div class="skeleton" style="margin:0 auto;height:35px;"></div>';
        jcLoader += '</div></div>';
        jcLoader += '</div>';
        jcLoader += '</div>';
        jcLoader += '</div><br />';
    } else if (sectionData.template == 'ranking-jc') {
        jcLoader = '<br /><div class="container">';
        jcLoader += '<div class="row">';
        jcLoader += '<div class="col-md-4 col-12 h-100"><div class="skeleton" ' + styleSkeleton + '></div></div>';
        jcLoader += '<div class="col-md-4 col-12 h-100"><div class="skeleton" ' + styleSkeleton + '></div></div>';
        jcLoader += '<div class="col-md-4 col-12 h-100"><div class="skeleton" ' + styleSkeleton + '></div></div>';
        jcLoader += '</div>';
        jcLoader += '<div class="row pt-3">';
        jcLoader += '<div class="col-md-4 col-12 h-100 d-none d-sm-block"><div class="skeleton" ' + styleSkeleton + '></div></div>';
        jcLoader += '<div class="col-md-4 col-12 h-100 d-none d-sm-block"><div class="skeleton" ' + styleSkeleton + '></div></div>';
        jcLoader += '<div class="col-md-4 col-12 h-100 d-none d-sm-block"><div class="skeleton" ' + styleSkeleton + '></div></div>';
        jcLoader += '</div>';
        jcLoader += '</div><br />';
    } else {
        jcLoader = '';
    }

    section.append(jcLoader);

    $.ajax({
        url: ajaxHandler.url,
        type: 'POST',
        data: sectionData,
        success: function success(response) {
            section.after(response.data.html);
            section.remove();
            setNextLazyWaypoint();
        },
        error: function error(data) {
            console.log('erro ajax');
        }
    });
}